import $ from 'cash-dom';
import { AcceptCookies } from './accept-cookies';
import Device from '../components/device';

let instance = null;

class StickyBanner {
	constructor() {
		if (!instance) {
			this._$stickyBannersListContainer = $('.sticky-banners-list');
			this._$lastStickyBannerContainer = null;
			this._wasClosed = false;
			this._mainTag = $('main');
			this._$templateNum = this._mainTag ? this._mainTag[0].className : '';
			this._itemSelector = 'vendor-id';
			this._mobileOrDesktopClass = '';

			instance = this;
		}

		return instance;
	}

	static getInstance() {
		if (!StickyBanner._instance) {
			StickyBanner._instance = new StickyBanner()
		}

		return StickyBanner._instance;
	}

	_$getStickyBannerContainer() {
		const firstVendorId = this._$getFirstVendor().data(this._itemSelector);
		let $stickyBanner = this._$stickyBannersListContainer.find('.sticky-banner-container-' + firstVendorId);

		if (!$stickyBanner.length && this._$lastStickyBannerContainer) {
			$stickyBanner = this._$lastStickyBannerContainer;
		}

		return $stickyBanner;
	}

	_$getFirstVendor() {
		return $('.vendors-list .ppc-single-vendor[data-pos="0"]' + this._mobileOrDesktopClass).not('.hidden');
	}

	init() {
		if (AcceptCookies.consented) {
			this._showOrHide();
		} else {
			$(document).on('cookies-consented', () => {
				setTimeout(() => {
					this._showOrHide();
				}, 1150);
			});
		}

		$(document).on('filters-change', () => {
			this._stickyBannerContainerHide();
			this._showOrHide();
		});

		this._$getStickyBannerContainer().find('.close-button').on('click', (e) => {
			e.preventDefault();

			this._stickyBannerContainerHide();
			this._wasClosed = true;
		});
	}

	_showOrHide() {
		if (this._isPositionToShow() && !this._wasClosed) {
			// we can already be in the position to show.
			// E.g. the page reload and previous needed scroll position was achieved.
			this._stickyBannerContainerShow();
		}

		const handleScroll = () => {
			if (this._wasClosed) {
				this._stickyBannerContainerHide();
				window.removeEventListener('scroll', handleScroll);
				return;
			}

			if (this._isPositionToShow()) {
				this._stickyBannerContainerShow();
			} else {
				this._stickyBannerContainerHide();
			}
		};

		window.addEventListener('scroll', handleScroll);
	}

	_isPositionToShow() {
		const firstVendor = this._$getFirstVendor().get(0);

		if (this._$templateNum === 'template-26' && firstVendor) {
			const firstVendorCTA = $(firstVendor).find('div.action a').get(0);
			return firstVendorCTA && firstVendorCTA.getBoundingClientRect().bottom < 0;
		}

		return firstVendor && firstVendor.getBoundingClientRect().bottom < 0;
	}

	_stickyBannerContainerShow() {
		const $stickyBannerContainer = this._$getStickyBannerContainer();

		const textSelector = this._isMobile()
			? '.sticky-banner-container .text-holder .text-mobile'
			: '.sticky-banner-container .text-holder .text-desktop';

		if ($stickyBannerContainer.find(textSelector).text().trim()) {
			$stickyBannerContainer.show();
			this._$lastStickyBannerContainer = $stickyBannerContainer;
		}
	}

	_isMobile() {
		return Device.isMobile() || Device.isTablet();
	}

	_stickyBannerContainerHide() {
		if (this._$lastStickyBannerContainer) {
			this._$lastStickyBannerContainer.hide();
		}
	}
}

export default StickyBanner;
